import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';

@Component({
  selector: 'app-blur-field',
  templateUrl: './blur-field.component.html',
  styleUrls: ['./blur-field.component.scss'],
})
export class BlurFieldComponent implements OnInit {
  @Input() product;
  @Input() companyName;
  isPremium = false;
  plan: any;
  isAdvance = false;
  isFree = false;
  sku: string;
  @Output() addToCartClick = new EventEmitter<any>();
  loginEmail: any;
  onSession: string;

  constructor(
    private localStorageService: LocalStorageService,
    private loginSignupService: LoginSignupService,
    private toastService: ToastService,
    private tansactionService: TansactionService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.loginEmail = this.loginSignupService.getUserSession()?.user?.name;
    this.onSession =  this.localStorageService.getItem('onSession');
    this.plan = this.localStorageService.getItem('plan');
    if(this.plan == null){
      this.plan = "free"
    }
    const redirectUrl = this.localStorageService.getItem('redirect_url');
  
  if (redirectUrl && redirectUrl.includes('/company')) {
    this.product.clicked = false;
    this.localStorageService.removeItem('redirect_url');
  }

    this.isProductFree(this.plan);
  }

  isProductFree(plan) {
    this.isFree = false;
    if((this.loginEmail == undefined || this.loginEmail == '' || this.loginEmail == null) && this.onSession == 'true'){
      this.isFree = false;
    }else{
      if (
        this.product.type == 'BSS' ||
        this.product.type == 'PLS' ||
        this.product.type == 'ROC'
      ) {
        if (plan == 'free' || plan == 'plan_advance') {
          this.isFree = false;
        } else {
          this.isFree = true;
        }
      } else {
        this.isFree = false;
      }
    }
  }

  addToCart(sku,product) {
    if (
      (this.loginEmail == undefined ||
      this.loginEmail == '' ||
      this.loginEmail == null) && (this.onSession == 'false' || this.onSession == null)
    ) {
      this.localStorageService.setItem("redirect_url",this.router.url);
      this.router.navigate(['/user/login']);
    } else {
      let currentOption;
      currentOption = {
        sku: sku,
      };
      this.tansactionService.addProductToCart(currentOption).then(
        (data: any) => {
          if (this.isFree == true) {
            this.toastService.addSingle(
              'success',
              'Email Sent',
              'Please check your email.'
            );
          } else {
            this.toastService.addSingle(
              'success',
              'Item added to cart',
              'Make payment to complete this transaction.'
            );
          }
          product.clicked = true;
        },
        (err) => {
          this.toastService.addSingle('error', 'Error', err.error.message);
        }
      );
    }
  }

  getProductShortName(name) {
      return name.replace(' - ' + this.companyName + '.pdf', '');
  }

  navigateToIndustryReport(){
    let isReport = false;
    this.router.navigate([`/company/${this.companyName}/product/${this.getProductShortName(this.product.name)}/${this.product.sku}/${isReport}`]);
  }

}
